/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */
const { logError } = require('src/utils/logger');
const defaults = require('../../factory/restrictions/defaults.json');
const SwearingFactory = require('../../factory/swearing');
const UserInfoFactory = require('../../factory/user-info');
const CompanyFactory = require('../../factory/company').instance;

function RestrictionsFactory () {}

RestrictionsFactory.prototype.initialize = function () {
  if (this.initializeDeferred) {
    return this.initializeDeferred;
  }

  this.initializeDeferred = $.Deferred();

  UserInfoFactory.get().then(_.bind(function (data) {
    const credentials = {
      username: data.credentials.token,
      password: data.credentials.hash
    };
    CompanyFactory.initialize()
      .then(_.bind(this.loadDesignInfo, this, credentials))
      .then(_.bind(this.loadTemplatePermissions, this))
      .then(_.bind(this.checkTemplatePermissions, this))
      .then(_.bind(this.checkElementPermissions, this))
      .then(_.bind(this.preloadSwearingLists, this))
      .then(_.bind(this.loadMissingAddOns, this))
      .then(_.bind(this.loadCompanyName, this))
      .then(this.initializeDeferred.resolve);
  }, this));

  return this.initializeDeferred.promise();
};

RestrictionsFactory.prototype.hasAddOnAndFeature = function (addOnName, feature) {
  if (!this.initializeDeferred) return true;

  let addOns = this.templatePermissions.get('addons');
  if (addOns === undefined) {
    addOns = this.companyAddOns?.get('add_ons') || {};
  }

  const addOn = addOns[addOnName];
  const hasAddOn = addOn !== undefined;
  const hasFeature = hasAddOn && feature && addOn.features && addOn.features.indexOf(feature) > -1;

  return !feature ? hasAddOn : hasAddOn && hasFeature;
};

RestrictionsFactory.prototype.loadDesignInfo = function (credentials, designCache) {
  const url = INKIVE.C.API_URL + 'brand/designs/' + INKIVE.C.BOOK.encodedId;
  const DesignModel = Backbone.Model.extend({
    url
  });

  if (designCache && designCache[url]) {
    return designCache[url];
  }

  const designModel = new DesignModel();
  designModel.credentials = credentials;
  try {
    return designModel.fetch();
  } catch (error) {
    throw new Error(JSON.stringify({ message: 'Design not found', error: error.message, function: 'RestrictionsFactory.prototype.loadDesignInfo' }));
  }
};

RestrictionsFactory.prototype.loadCompanyName = function () {
  const that = this;
  return CompanyFactory.getCompany().then(function (company) {
    that.companyName = company.name;
  });
};

RestrictionsFactory.prototype.loadMissingAddOns = function () {
  const companyGetContainer = _.bind(CompanyFactory.getContainer, CompanyFactory);

  this.companyAddOns = companyGetContainer('settings').models[0];
};

RestrictionsFactory.prototype.preloadSwearingLists = function () {
  const swearingLocales = [];
  this.elementsPermissions.each(function (model) {
    const restriction = JSON.parse(model.get('restrictions'));

    if (restriction?.swearing) {
      for (const locale in restriction.swearing) {
        if (!restriction.swearing[locale]) continue;
        swearingLocales.includes(locale) || swearingLocales.push(locale);
      }
    }
  });

  return SwearingFactory.preloadSwearingLists(swearingLocales);
};

RestrictionsFactory.prototype.checkTemplatePermissions = function (templateData, elementData) {
  if (!elementData) return;

  if (typeof elementData?.[0] === 'undefined') {
    return this.loadEmptyTemplatePermissions();
  } else {
    return [templateData?.[0], elementData?.[0]];
  }
};

RestrictionsFactory.prototype.checkElementPermissions = function () {
  this.elementsPermissions.reset(this.filterBrokenPermissions(this.elementsPermissions.models));
};

RestrictionsFactory.prototype.filterBrokenPermissions = function (permissions) {
  return permissions.filter(item => {
    try {
      JSON.parse(item.attributes.restrictions);
      return true;
    } catch (error) {
      console.warn('Broken element permission detected:', item.attributes);
      logError('FilterBrokenPermissions', item.attributes)(error);
      return false;
    }
  });
};

RestrictionsFactory.prototype.loadTemplatePermissions = function (designData) {
  if (!designData || !designData.template) {
    return this.loadEmptyTemplatePermissions();
  }
  const companyGetContainer = _.bind(
    CompanyFactory.getContainer, CompanyFactory,
    'templates', designData.template
  );

  this.templatePermissions = companyGetContainer('templatepermissions', 'me');
  this.elementsPermissions = companyGetContainer('elementpermissions');

  return $.when(this.templatePermissions.fetch(), this.elementsPermissions.fetch());
};

RestrictionsFactory.prototype.loadEmptyTemplatePermissions = function () {
  const elementPermissions = _.map(_.range(1, INKIVE.C.BOOK.num_pages + 1), function (page) {
    return {
      page_number: page,
      element_id: 'background',
      restrictions: JSON.stringify(defaults.loose.background)
    };
  });

  this.templatePermissions = new Backbone.Model(defaults.loose);
  this.elementsPermissions = new Backbone.Collection(elementPermissions);

  return $.when(CompanyFactory.get(['settings']));
};

RestrictionsFactory.prototype.constructor = RestrictionsFactory;
module.exports = RestrictionsFactory;
